import { render } from "./CarouselAlojamiento.vue?vue&type=template&id=5f456e41&scoped=true"
import script from "./CarouselAlojamiento.vue?vue&type=script&lang=js"
export * from "./CarouselAlojamiento.vue?vue&type=script&lang=js"

import "./CarouselAlojamiento.vue?vue&type=style&index=0&id=5f456e41&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f456e41"]])

export default __exports__